// Video Vendors
export const JWPLAYER_VENDOR = 1;
export const VIDEO_JS_VENDOR = 2;
export const AD_PLAYER_PRO_VENDOR = 3;

// Ad Server Vendors
export const GAM_VENDOR = 'gam';

export type AdServerVendor = typeof GAM_VENDOR;
